import { axiosInstanceV1 } from "@bn/api";
import { BanksApiBanksRequest, BankWrapperList } from "@bn/api/apiv1";

export const getBanksBySearch = async (
  token: string | undefined,
  params: BanksApiBanksRequest
) => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

  const { data } = await axiosInstanceV1.get<BankWrapperList>(`/banks`, {
    headers,
    params,
  });
  return data;
};
